import React, { Component } from 'react';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import './App.css';
import Routes from './routes';

class App extends Component {
  public render(): JSX.Element {
    return (
      <Provider store={configureStore as any}>
        <Routes />
      </Provider>
    );
  }
}

export default App;
